import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types"; // 👈 tämä tarvitaan

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <ModalContext.Provider value={{ isModalOpen, setIsModalOpen }}>
      {children}
    </ModalContext.Provider>
  );
};

// ✅ Prop-types korjaus
ModalProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useModal = () => useContext(ModalContext);
